import { UrnaComponent } from './urna/urna.component';
import { IndexComponent } from './index/index.component';
import { Erro404Component } from './erro404/erro404.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {CardCandidatoComponent } from './card-candidato/card-candidato.component'


const routes: Routes = [
  {  path: '', component: IndexComponent} ,
  {  path: 'urna', component: UrnaComponent} ,
  {  path: 'urna/:id', component: UrnaComponent} ,
  {  path: 'card-candidato/:id', component: CardCandidatoComponent } ,
  {  path: 'index', component: IndexComponent} ,
  {  path: '**', component: Erro404Component }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule ],
  declarations: []
})
export class AppRoutingModule { }
